<template>
  <div class="home_m">
    <Header :facilityHead="facilityM" />
    <div class="banner_swipe_box">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerImg" :key="index">
          <img :src="getImgUrl(item.path)" style="width: 100%; height: 100%" alt="banner图" />
          <div class="banner_bg"></div>
          <div class="banner_info">
            <p class="title_en">{{ item.english }}</p>
            <div class="title">{{ item.title }}</div>
            <div class="title_child">
              <div v-for="(val, i) in item.child" :key="i">{{ val }}</div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="menus_icon_box">
      <div
        class="icon_box"
        v-for="(item, index) in navigation.slice(1, navigation.length)"
        :key="index"
        @click="handleNavItem(item, index)"
      >
        <i :class="'iconfont' + ' ' + item.icon"></i>
        <p>{{ item.title }}</p>
      </div>
    </div>

    <div class="product_box" v-for="(item, index) in navigation.slice(1, 3)" :key="index">
      <div class="title_box">
        <span class="title">{{ item.title }}</span>
        <span class="name">丨{{ item.path }}</span>
      </div>
      <div
        class="product_item"
        v-for="(val, i) in item.child"
        :key="i"
        @click="handleNavItem(item, index, val)"
      >
        <div class="left_item">
          <i :class="'iconfont' + ' ' + val.icon"></i>
          <span>{{ val.name }}</span>
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>

    <div class="company_box">
      <div class="title_box">
        <span class="title">公司介绍</span>
        <span class="name">丨company</span>
      </div>
      <div class="company_text">
        <p>武汉岩石科技有限公司，简称:岩石科技，前身为拓普康中国与北京奥腾岩石科技武汉技术研发中心、武汉大学测绘学院教学实习基地，曾为中国用户提供技术服务近十年。公司坐落于武汉市野芷湖畔， 是一家专业从事地理信息装备及技术应用的高新技术企业，公司立足地理信息行业，致力于安全监测领域的开拓和发展。</p>
        <p>公司通过了5项ISO体系认证并取得证书，获得多项软件著作权证书和专利证书，获得乙级测绘资质证书， 是科技部认定的高新技术企业，是武汉市科技局认定的科技“小巨人”企业，是湖北省软件行业协会认定的“双软”企业，是武汉市软件行业协会理事单位，是湖北省测绘行业会员单位。</p>
        <p>公司拥有”起迈安全”和”QimySafe”注册商标，提供全方位一站式安全监测解决方案以及端到端的技术服务。岩石科技深耕行业十余年始终以客户需求为导向，提供场景化解决方案。公司始终坚持以创新驱动、技术引领的发展理念，在数字定义世界、软件定义未来的时代，将物连网、云计算、边缘计算机学与多源传感器相结合，构建智能综合安全的监测生态圈。公司产品和解决方案广泛应用于轨道交通、建设工程、基坑监测、桥隧健康、水利水电、地质灾害、矿山安全与文物遗址等领域，获得了广大用户的好评。面向未来，岩石科技将与广大客户和合作伙伴一道，为基础设施建设与运维保驾护航。</p>
        <p>我们的愿景：成为全球领先的安全监测解决方案供应商</p>
        <p>我们的使命：为员工创造平台 为客户创造价值 为社会创造效益</p>
      </div>
      <van-button round type="default" @click="handleUs">了解更多</van-button>
    </div>

    <Footer :facilityFooter="facilityM" />
  </div>
</template>

<script>
import Header from '../../components/headers.vue'
import Footer from '../../components/footers.vue'
import homeData from '@/static/data.json'
import Vue from 'vue'
import { Swipe, SwipeItem, Button } from 'vant'
Vue.use(Swipe)
  .use(SwipeItem)
  .use(Button)

export default {
  name: 'home_m',
  data () {
    return {
      navigation: [], // 导航栏
      bannerImg: [] // banner
    }
  },

  created () {
    this.navigation = homeData.data.navigation
    this.bannerImg = homeData.data.banner
  },

  props: ['facilityM'],

  methods: {
    handleNavItem (item, index, val) {
      let navigation
      if (val) {
        this.$router.push(item.path)
        navigation = {
          title: item.title,
          index: index,
          child: {
            name: val.name
          }
        }
        this.resetSetItem('navigation', JSON.stringify(navigation))
      } else {
        this.$router.push(item.path)
        navigation = {
          title: item.title,
          index: item.index
        }
        this.resetSetItem('navigation', JSON.stringify(navigation))
      }
    },

    handleUs () {
      this.$router.push('aboutUs')
    },

    getImgUrl (src) {
      return require('@/assets/home/' + src)
    }
  },

  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss" scoped>
.home_m {
  font-family: PingFang SC;
  padding: 0.15rem;
  .banner_swipe_box {
    position: relative;
    .van-swipe {
      .van-swipe-item {
        height: 3.31rem;
      }
    }
    .banner_bg {
      position: absolute;
      top: 0;
      background: rgba($color: #000000, $alpha: 0.2);
      width: 100%;
      height: 100vh;
    }
    .banner_info {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 10;
      font-size: 0.3rem;
      color: #fff;
      font-weight: bold;
      text-align: center;

      .title_en {
        font-size: 0.14rem;
      }
      .title {
        font-size: 0.48rem;
        font-weight: bold;
        border-bottom: 0.02rem #fff solid;
        display: inline-block;
        padding-bottom: 0.1rem;
        margin-bottom: 0.2rem;
      }
      .title_child {
        display: flex;
        flex-wrap: wrap;
        width: 2.1rem;
        div {
          width: 1rem;
          background-color: #fff;
          margin-bottom: 0.1rem;
          color: #5289f4;
          text-align: center;
          font-weight: bold;
          line-height: 0.3rem;
          border-radius: 0.05rem 0.05rem;
          font-size: 0.12rem;
        }
        div:nth-child(2n) {
          margin-left: 0.06rem;
        }
      }
    }
  }
  .menus_icon_box {
    display: flex;
    justify-content: space-between;
    margin: 0.25rem 0 0.35rem 0;
    .icon_box {
      text-align: center;
      i {
        color: #aaaaaa;
        font-size: 0.4rem;
      }
      p {
        margin-top: 0.08rem;
        font-size: 0.1rem;
      }
    }
  }
  .product_box {
    margin-top: 0.15rem;
    .product_item {
      display: flex;
      justify-content: space-between;
      width: 100%;
      border: 1px #eee solid;
      margin-top: 0.1rem;
      .left_item {
        margin: 0.12rem 0 0.12rem 0.1rem;
        i {
          color: #295795;
          font-size: 0.16rem;
          margin-right: 0.2rem;
        }
        span {
          font-size: 0.1rem;
          color: #333;
        }
      }
      .el-icon-arrow-right {
        margin: 0.18rem 0.3rem;
        font-size: 0.1rem;
      }
    }
  }
  .company_box {
    margin-top: 0.2rem;
    .company_text {
      font-size: 0.1rem;
      color: #999;
      margin: 0.1rem 0 0.15rem 0;
      line-height: 0.19rem;
      text-transform: uppercase;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 12; /*显示的行数*/
      overflow: hidden;
      p {
        text-indent: 2em;
      }
    }
    button {
      height: 0.32rem;
      font-size: 0.08rem;
      margin: 0 auto;
      color: #999;
      display: block;
    }
  }
  .title_box {
    font-size: 0.12rem;
    font-weight: bold;
    .title {
      color: #295795;
      border-left: 0.04rem solid #295795;
      padding: 0 0.05rem;
    }
    .name {
      color: #999;
      text-transform: capitalize !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/index_m.vue